/** Debug trace for Google / social loginRedirect (filter console by `[he-auth][google-flow]`). */
const TAG = '[he-auth][google-flow]';

export function logGoogleFlow(
  event: string,
  detail: Record<string, unknown> = {}
): void {
  const page =
    typeof window !== 'undefined'
      ? {
          href: window.location.href,
          pathname: window.location.pathname,
          search: window.location.search,
        }
      : null;
  console.log(TAG, event, {
    ...detail,
    page,
    at: new Date().toISOString(),
  });
}

export function logGoogleFlowRedirect(
  event: string,
  targetUrl: string,
  detail: Record<string, unknown> = {}
): void {
  logGoogleFlow(event, { ...detail, redirectTo: targetUrl });
}
